/**
 * 埋め込みサムネイルの角丸 ON/OFF（タイル型・スライダー型 共通モジュール）。
 *
 * 管理画面（プレイリスト詳細）で切り替え、scenario.config.thumbnailRounded に
 * プレイリスト単位で保存する。埋め込み側（TilePlayer / SliderPlayer / StandalonePlayer）と
 * 管理画面プレビューの両方で同じ値を参照する。
 *
 * 既定は ON（従来の見た目）。先方サイトのデザインが直角基調で角丸が浮くときだけ OFF にする。
 * 角丸の量は選べない（ON=既定値 / OFF=0）。
 */

/** 未設定（旧データ）の既定値。従来の見た目を保つため角丸あり。 */
export const DEFAULT_THUMBNAIL_ROUNDED = true

/**
 * 不正な値（旧データや手動編集された JSON）から安全な既定値へフォールバックする。
 */
export function normalizeThumbnailRounded(value: unknown): boolean {
  return typeof value === 'boolean' ? value : DEFAULT_THUMBNAIL_ROUNDED
}

/**
 * 埋め込みプレイヤーの <style> 内で使う border-radius 値。
 * OFF のときは 0 にするだけで、レイアウト（比率・余白）には影響させない。
 */
export const THUMBNAIL_RADIUS_SP = '10px'
export const THUMBNAIL_RADIUS_PC = '16px'

/** ON/OFF に応じた border-radius 値を返す（インライン style / <style> タグ用）。 */
export function thumbnailRadius(rounded: boolean, radius: string): string {
  return rounded ? radius : '0px'
}
